class AnniversaryCandleDialog extends ModalDialog {
  constructor() {
    super();

    this.loadedAssets = false;
    if (!this.dataset.lazyload) {
      this.loadAssets();
    }
  }

  loadAssets() {
    if (this.loadedAssets) {
      return;
    }
    this.loadedAssets = true;
    if (this.dataset.scripts) {
      this.dataset.scripts.split(',').forEach(function(url) {
        if (url) loadThemeScript(url);
      })
    }
    if (this.dataset.stylesheets) {
      this.dataset.stylesheets.split(',').forEach(function(url) {
        if (!url) return;
        const link = document.createElement("link");
        link.type = "text/css";
        link.rel = "stylesheet";
        link.href = url;
        document.head.appendChild(link);
      })
    }
  }

  show(opener) {
    this.loadAssets();
    super.show(opener);
  }
}
customElements.define("anniversary-candle-dialog", AnniversaryCandleDialog);
